<script>
  import { Router, Route } from "./router";
  import Home from "./routes/Home.svelte";
  import Pricing from "./routes/Pricing.svelte";
  import Help from "./routes/Help.svelte";
  import Dashboard from "./routes/Dashboard.svelte";
  import Select from "./routes/Select.svelte";
  import Guests from "./routes/Guests.svelte";
  import Mailing from "./routes/Mailing.svelte";
  import Wedding from "./routes/Wedding.svelte";
  import Rsvp from "./routes/Rsvp.svelte";
  import Champiz from "./routes/Champiz.svelte";
  import Quizz from "./routes/Quizz.svelte";
</script>

<Router>
  <Route path="/">
    <Home />
  </Route>
  <Route path="/pricing" component={Pricing} />
  <Route path="/help" component={Help} />
  <Route path="/select/*wedding_guid" component={Select} />
  <Route path="/dashboard/:wedding_guid" component={Dashboard} />
  <Route path="/rsvp/:wedding_guid" component={Rsvp} />
  <Route path="/guests/:wedding_guid" component={Guests} />
  <Route path="/mailing/:wedding_guid" component={Mailing} />
  <Route path="/wedding/:wedding_guid/:category/*article_id" component={Wedding} />
  <Route path="/champiz/:wedding_guid" component={Champiz} />
  <Route path="/quizz/:wedding_guid/:tab" component={Quizz} />
</Router>
